import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import eImg from '../../../img/pepe.png';
import jImg from '../../../img/moldura.png';
import lImg from '../../../img/moldu.png';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const CarruselModerno = () => {
  const [diapositivaActual, setDiapositivaActual] = useState(0);
  const [estaSobrevolado, setEstaSobrevolado] = useState(false);
  const navegar = useNavigate();

  const diapositivas = [
    {
      imagen: eImg,
      titulo: "Molduras Premium",
      subtitulo: "Colección Exclusiva",
      descripcion: "Descubre el arte en cada detalle de nuestras molduras ",
      etiqueta: "Nuevo"
    },
    {
      imagen: jImg,
      titulo: "Diseño Contemporáneo",
      subtitulo: "Innovación y Estilo",
      descripcion: "Molduras que transforman espacios con elegancia moderna",
      etiqueta: "Destacado"
    },
    {
      imagen: lImg,
      titulo: "Acabados Perfectos",
      subtitulo: "Calidad Superior",
      descripcion: "Experiencia y precisión en cada pieza que creamos",
      etiqueta: "Popular"
    }
  ];

  const manejarNavegacion = () => {
    navegar('/productos');
  };

  useEffect(() => {
    if (!estaSobrevolado) {
      const temporizador = setInterval(() => {
        setDiapositivaActual((prev) => (prev + 1) % diapositivas.length);
      }, 5000);
      return () => clearInterval(temporizador);
    }
  }, [estaSobrevolado]);

  const irADiapositiva = (indice) => {
    setDiapositivaActual(indice);
  };

  const siguienteDiapositiva = () => {
    setDiapositivaActual((prev) => (prev + 1) % diapositivas.length);
  };

  const diapositivaAnterior = () => {
    setDiapositivaActual((prev) => (prev === 0 ? diapositivas.length - 1 : prev - 1));
  };

  return (
    <div 
      className="relative w-full h-screen max-h-[600px] overflow-hidden bg-gray-900 group"
      onMouseEnter={() => setEstaSobrevolado(true)}
      onMouseLeave={() => setEstaSobrevolado(false)}
    >
      {/* Contenedor de Diapositivas */}
      <div className="relative w-full h-full">
        {diapositivas.map((diapositiva, indice) => (
          <div
            key={indice}
            className={`absolute inset-0 w-full h-full transition-all duration-700 ease-in-out transform
              ${indice === diapositivaActual ? 'opacity-100 translate-x-0 z-10' : 
                indice < diapositivaActual ? 'opacity-0 -translate-x-full z-0' : 'opacity-0 translate-x-full z-0'}`}
          >
            {/* Patrón de Fondo */}
            <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 to-purple-900/20 z-10" />
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,rgba(0,0,0,0.6)_100%)]" />
            
            {/* Imagen */}
            <img
              src={diapositiva.imagen}
              alt={diapositiva.titulo}
              className="object-cover object-center w-full h-full transform transition-transform duration-15000 hover:scale-110"
            />
            
            {/* Contenido Superpuesto */}
            <div className="absolute inset-0 flex items-center justify-center z-20">
              <div className="max-w-4xl mx-6 text-center">
                <div className="inline-block px-4 py-2 mb-6 bg-white/10 backdrop-blur-md rounded-full">
                  <span className="text-sm font-medium text-white">{diapositiva.etiqueta}</span>
                </div>
                <h3 className="text-lg text-white/90 font-medium mb-3 tracking-wider">
                  {diapositiva.subtitulo}
                </h3>
                <h2 className="text-5xl font-bold text-white mb-6 tracking-tight">
                  {diapositiva.titulo}
                </h2>
                <p className="text-xl text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
                  {diapositiva.descripcion}
                </p>
                <button 
                  onClick={manejarNavegacion}
                  className="px-8 py-3 bg-white text-gray-900 rounded-lg font-semibold 
                  hover:bg-opacity-90 transition-all duration-300 transform hover:scale-105">
                  Explorar Colección
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Controles de Navegación */}
      <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-black/50 to-transparent z-30" />
      
      {/* Flechas de Navegación */}
      <button
        onClick={diapositivaAnterior}
        className="absolute left-4 top-1/2 -translate-y-1/2 z-30 p-3 rounded-full
          bg-black/30 backdrop-blur-sm hover:bg-white/30 transition-all duration-300
          opacity-0 group-hover:opacity-100 transform -translate-x-10 group-hover:translate-x-0"
      >
        <ChevronLeft className="w-6 h-6 text-white" />
      </button>
      <button
        onClick={siguienteDiapositiva}
        className="absolute right-4 top-1/2 -translate-y-1/2 z-30 p-3 rounded-full
          bg-black/30 backdrop-blur-sm hover:bg-white/30 transition-all duration-300
          opacity-0 group-hover:opacity-100 transform translate-x-10 group-hover:translate-x-0"
      >
        <ChevronRight className="w-6 h-6 text-white" />
      </button>

      {/* Navegación Inferior */}
      <div className="absolute bottom-8 left-0 right-0 z-30">
        <div className="flex flex-col items-center">
          {/* Barra de Progreso */}
          <div className="w-64 h-1 bg-white/20 rounded-full overflow-hidden">
            <div 
              className="h-full bg-white/80 transition-all duration-500 ease-out"
              style={{ width: `${((diapositivaActual + 1) / diapositivas.length) * 100}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarruselModerno;
